export enum TaskCompletionStatus {
  Incomplete,
  Complete,
  Skip
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/user-task/task-completion-status.ts